import { Button, CircularProgress } from '@mui/material';
import type { ButtonProps } from '@mui/material/Button';
import * as React from 'react';

export type LoadingButtonProps = ButtonProps & {
  loading: boolean;
};

export const LoadingButton = React.forwardRef<
  HTMLButtonElement,
  LoadingButtonProps
>((props, ref) => {
  const { loading, children, ...buttonProps } = props;

  return (
    <Button
      {...buttonProps}
      disabled={loading || buttonProps.disabled}
      ref={ref}
    >
      {loading ? <CircularProgress size={22} sx={{ mr: 0.5 }} /> : null}
      {children}
    </Button>
  );
});
